module.exports = __webpack_public_path__ + "img/taegeuk.bb14452.png";